import { createSelector } from '@ngrx/store';

import { getAppDomainState } from 'src/app/modules/ngrx-store/selectors';
import { State } from 'src/app/modules/ngrx-store/realtor/realtor.reducer';

/**
 * loadRealtorAccess
 */
export const getRealtorAccessStatus = createSelector(
	getAppDomainState,
	(state: State) => state.realtorAccess
);

export const getRealtorAccessFailure = createSelector(
	getAppDomainState,
	(state: State) => state.loadRealtorAccessFailure
);

export const getRealtorAccessPending = createSelector(
	getAppDomainState,
	(state: State) => state.loadRealtorAccessPending
);

export const getRealtorAccessSuccess = createSelector(
	getAppDomainState,
	(state: State) => state.loadRealtorAccessSuccess
);

/**
 * acknowledgeRealtorAccess
 */
export const getAcknowledgeRealtorAccessFailure = createSelector(
	getAppDomainState,
	(state: State) => state.acknowledgeRealtorAccessFailure
);

export const getAcknowledgeRealtorAccessPending = createSelector(
	getAppDomainState,
	(state: State) => state.acknowledgeRealtorAccessPending
);

export const getAcknowledgeRealtorAccessSuccess = createSelector(
	getAppDomainState,
	(state: State) => state.acknowledgeRealtorAccessSuccess
);

/**
 * removeRealtorAccess
 */
export const getRemoveRealtorAccessFailure = createSelector(
	getAppDomainState,
	(state: State) => state.removeRealtorAccessFailure
);

export const getRemoveRealtorAccessPending = createSelector(
	getAppDomainState,
	(state: State) => state.removeRealtorAccessPending
);

export const getRemoveRealtorAccessSuccess = createSelector(
	getAppDomainState,
	(state: State) => state.removeRealtorAccessSuccess
);

/**
 * reactivateRealtorAccess
 */
export const getReactivateRealtorAccessFailure = createSelector(
	getAppDomainState,
	(state: State) => state.reactivateRealtorAccessFailure
);

export const getReactivateRealtorAccessPending = createSelector(
	getAppDomainState,
	(state: State) => state.reactivateRealtorAccessPending
);

export const getReactivateRealtorAccessSuccess = createSelector(
	getAppDomainState,
	(state: State) => state.reactivateRealtorAccessSuccess
);

/**
 * createRealtorGrant
 */
export const getCreateRealtorGrantFailure = createSelector(
	getAppDomainState,
	(state: State) => state.createRealtorGrantFailure
);

export const getCreateRealtorGrantPending = createSelector(
	getAppDomainState,
	(state: State) => state.createRealtorGrantPending
);

export const getCreateRealtorGrantSuccess = createSelector(
	getAppDomainState,
	(state: State) => state.createRealtorGrantSuccess
);

/**
 * loadRealtorGrants
 */
export const getRealtorGrants = createSelector(
	getAppDomainState,
	(state: State) => state.realtorGrants
);

export const getRealtorGrantsFailure = createSelector(
	getAppDomainState,
	(state: State) => state.loadRealtorGrantsFailure
);

export const getRealtorGrantsPending = createSelector(
	getAppDomainState,
	(state: State) => state.loadRealtorGrantsPending
);

export const getRealtorGrantsSuccess = createSelector(
	getAppDomainState,
	(state: State) => state.loadRealtorGrantsSuccess
);

/**
 * loadVisit
 */
export const getVisit = createSelector(
	getAppDomainState,
	(state: State) => state.visit
);

/**
 * upsertVisit
 */
export const getUpsertVisitFailure = createSelector(
	getAppDomainState,
	(state: State) => state.upsertVisitFailure
);

export const getUpsertVisitPending = createSelector(
	getAppDomainState,
	(state: State) => state.upsertVisitPending
);

export const getUpsertVisitSuccess = createSelector(
	getAppDomainState,
	(state: State) => state.upsertVisitSuccess
);

/**
 * showClientManagement
 */
export const showClientManagement = createSelector(
	getAppDomainState,
	(state: State) => !!state.realtorGrants && state.realtorGrants.length > 1
);

/**
 * getOpenClientManagementModal
 */
export const getOpenClientManagementModal = createSelector(
	getAppDomainState,
	(state: State) => state.openClientManagementModal ?? false
);

/**
 * previewRealtorEmail
 */
export const getPreviewRealtorEmail = createSelector(
	getAppDomainState,
	(state: State) => state.previewRealtorEmail
);